import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import WeBelieve from './WeBelieve';
import Ministries from './Ministries';
import LatestYoutubeVideo from './LatestYoutubeVideo';
import ContactSection from './ContactSection';
import ImgBienvenido from './ImgBienvenido';
import QuienesSomos from './QuienesSomos';
import { setJsonLd, setLinkTag, setMetaTag } from '../utils/seo';

const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    const baseUrl = 'https://iglesiacanaldevida.com';
    const pageUrl = `${baseUrl}/`;
    const title = 'Iglesia Canal de Vida | Córdoba, Argentina';
    const description =
      'Queremos ayudarte a encontrarte con Jesús, conectar con una comunidad que te abraza y crecer en la fe junto a otros.';
    const imageUrl = `${baseUrl}/assets/images/favicons/apple-touch-icon-2.png`;

    document.title = title;
    document.documentElement.setAttribute('lang', 'es-AR');

    setLinkTag('canonical', pageUrl);
    setMetaTag('name', 'description', description);
    setMetaTag('property', 'og:type', 'website');
    setMetaTag('property', 'og:site_name', 'Iglesia Canal de Vida');
    setMetaTag('property', 'og:title', title);
    setMetaTag('property', 'og:description', description);
    setMetaTag('property', 'og:url', pageUrl);
    setMetaTag('property', 'og:image', imageUrl);
    setMetaTag('property', 'og:locale', 'es_AR');
    setMetaTag('name', 'twitter:card', 'summary');
    setMetaTag('name', 'twitter:title', title);
    setMetaTag('name', 'twitter:description', description);
    setMetaTag('name', 'twitter:image', imageUrl);

    setJsonLd('church-jsonld', {
      '@context': 'https://schema.org',
      '@type': 'Church',
      name: 'Iglesia Canal de Vida',
      url: pageUrl,
      logo: imageUrl,
      image: imageUrl,
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Antártida Argentina 3868',
        addressLocality: 'Córdoba',
        addressRegion: 'Córdoba',
        addressCountry: 'AR'
      },
      telephone: '351-051842',
      email: 'contacto@iglesiacanaldevida.com',
      areaServed: 'Córdoba, Argentina',
      sameAs: ['https://www.youtube.com/@iglesiacanaldevida']
    });
  }, []);

  useEffect(() => {
    const targetId = location.state?.scrollTo;
    if (!targetId) return;

    const attemptScroll = () => {
      const targetEl = document.querySelector(targetId);
      if (!targetEl) return false;
      const styles = getComputedStyle(document.documentElement);
      const headerHeight = parseInt(styles.getPropertyValue('--header-height'), 10) || 0;
      const anchorOffset = parseInt(styles.getPropertyValue('--anchor-offset'), 10) || 0;
      const offset = headerHeight + anchorOffset;
      const targetTop = targetEl.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: targetTop, behavior: 'smooth' });
      window.history.replaceState(null, '', targetId);
      return true;
    };

    if (!attemptScroll()) {
      const timeoutId = setTimeout(() => attemptScroll(), 120);
      return () => clearTimeout(timeoutId);
    }
  }, [location.state]);

  return (
    <div className="page-wrapper" style={{ position: 'relative', zIndex: 1 }}>
      <Header />
      <ImgBienvenido />
      <QuienesSomos />
      <Ministries />
      <WeBelieve />
      <LatestYoutubeVideo />
      <ContactSection />
    </div>
  );
};

export default HomePage;
